import { createContext } from "preact";
import { AdminClient } from "../../client";

export const AdminClientContext = createContext(new AdminClient());
